import vInfoIcon from "./v-infoicon.vue";

export default Vue => {
  Vue.component("v-infoicon", vInfoIcon);
};
